/* src/app/components/confirm-popover/confirm-popover.component.scss */
.container {
  padding: 5px 25px;
}
.description {
  padding: 10px 5px;
}
.highlight {
  font-weight: bold !important;
}
h3 {
  font-weight: bold;
}
.responsive-size {
  height: 400px;
}
@media only screen and (max-width: 540px) {
  .responsive-size {
    height: 800px;
  }
}
/*# sourceMappingURL=confirm-popover.component-DUSJJXKZ.css.map */
